export class ChangePasswordModel {

  constructor() {
    this.password = '';
    this.password_confirmation = '';
    this._apiAttributes = {
      password: 'password'
    };
  }

}
